import { render, staticRenderFns } from "./table-row.payments-dashboard.vue?vue&type=template&id=9bc9dc32&scoped=true&"
import script from "./table-row.payments-dashboard.vue?vue&type=script&lang=js&"
export * from "./table-row.payments-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./table-row.payments-dashboard.vue?vue&type=style&index=0&id=9bc9dc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc9dc32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
